import React from 'react';

export function Index() {
    return <>Welcome to MarketingApp.</>;
}

export default Index;
